import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ModalAddProject from '../ShareProject/ModelShareProject';
import Button from '../atoms/button';

const propTypes = {
  name: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  sharedProjectData: PropTypes.array.isRequired,
  profiles: PropTypes.array.isRequired,
  project: PropTypes.oneOfType([PropTypes.object]),
};

const ShareProjectButton = ({ name, onDone, sharedProjectData, profiles, project }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  return (
    <>
      <Button primary onClick={handleOpen}>{name}</Button>
      <ModalAddProject
        openToggle={openDialog}
        handleClose={handleClose}
        onDone={onDone}
        sharedProjectData={sharedProjectData}
        profiles={profiles}
        project={project}
      />
    </>
  );
};

ShareProjectButton.propTypes = propTypes;
export default ShareProjectButton;
